// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
import React from "react"
import { classNames } from "@plasmicapp/react-web"

export function Slider2Icon(props) {
  const { className, style, title, ...restProps } = props
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 71 8"}
      height={"1em"}
      width={"1em"}
      style={{
        fill: "currentcolor",
        ...(style || {}),
      }}
      className={classNames("plasmic-default__svg", className)}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <circle
        opacity={".3"}
        cx={"24.75"}
        cy={"3.75"}
        r={"3.75"}
        fill={"currentColor"}
      ></circle>

      <circle
        opacity={".3"}
        cx={"45.75"}
        cy={"3.75"}
        r={"3.75"}
        fill={"currentColor"}
      ></circle>

      <circle
        opacity={".3"}
        cx={"66.75"}
        cy={"3.75"}
        r={"3.75"}
        fill={"currentColor"}
      ></circle>

      <circle cx={"3.75"} cy={"3.75"} r={"3.75"} fill={"currentColor"}></circle>
    </svg>
  )
}

export default Slider2Icon
/* prettier-ignore-end */
